<div class="dashboard-container">
  <!-- Header Bar with Welcome and Generate Button -->
  <div class="dashboard-header">
    <div class="welcome-section">
      <h2 class="welcome-text">Welcome {{ presentUser }}</h2>
      <div class="date-display">{{ today | date:'EEEE, MMMM d, y' }}</div>
    </div>
    
    <button class="btn btn-primary generate-btn" 
            routerLink="/datasrc" 
            routerLinkActive="active">
      <i class="bi bi-database-gear"></i> Generate Synthetic Test Data
    </button>
  </div>
  
  <!-- Dashboard Content -->
  <div class="dashboard-content">
    <!-- Stats Cards Row -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="bi bi-database-check"></i>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ database_count }}</div>
          <div class="stat-label">Databases Available</div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">
          <i class="bi bi-filetype-py"></i>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ script_Count }}</div>
          <div class="stat-label">Total Scripts Generated</div>
        </div>
      </div>
      
      <div class="help-options">
        <div class="help-option">  
          <a href="https://wiki.app.pconnect.biz/display/OPD/STDG+-+User+Guide"
              class="help-option-link"
              target="_blank">
            <div class="help-icon">
              <i class="bi bi-journal-text"></i>
            </div>
            <div class="help-label">
              Quick Start Guide
            </div>
          </a>
        </div>
        
        <div class="help-option">
          <div class="help-option-link" (click)="openFAQSection()">
            <div class="help-icon">
              <i class="bi bi-question-circle"></i>
            </div>
            <div class="help-label">FAQ Section</div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Scripts Table Card -->
    <div class="table-card">
      <div class="card-header">
        <h5>Recent Scripts</h5>
      </div>
      
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Script Name</th>
              <th>Created By</th>
              <th>Last Modified</th>
              <th class="actions-column">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let script of displayScripts; let i = index">
              <td>{{ script.name }}</td>
              <td>{{ script.metadata.created_by }}</td>
              <td>{{ script.last_modified }}</td>
              <td class="actions-column">
                <div class="action-icons">
                  <button class="action-icon" 
                         (click)="viewFile(script.name, 'script')" 
                         title="View Script">
                    <i class="bi bi-file-code"></i>
                  </button>
                  
                  <button class="action-icon" 
                         (click)="viewFile(script.name, 'validation')" 
                         title="View Validation">
                    <i class="bi bi-check-circle"></i>
                  </button>
                  
                  <button class="action-icon" 
                         (click)="viewMetadataFile(script.metadata.metadata_filepath)" 
                         title="View Metadata">
                    <i class="bi bi-info-circle"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>